//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['website'],
	methods: {
		savePageSettings: function savePageSettings() {
			var _this = this;

			var $el = this;

			var data = $el.website;

			axios.post('/prototype/website/' + $el.website.id, $el.website).then(function (response) {
				if (response.data.error) {
					_this.$snotify.error('Error saving contact data: ' + response.data.error);
				} else {
					_this.$snotify.success('Website settings were updated');
					Event.$emit('refresh-property-website', $el.website.property_id);
				}
			});
		}
	},
	mounted: function mounted() {
		this.website.property_name = this.website.property_name ? this.website.property_name : this.website.property.name;
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/CMSSettings.vue
// module id = aGhI
// module chunks = 0 1